import mapValues from 'lodash/mapValues';
import invert from 'lodash/invert';
import fromPairs from 'lodash/fromPairs';

const nbsp = '\u00A0';

const humanToId = {
  'Flatbed': 'F',
  'Van': 'V',
  'Reefer': 'R',
  'Stepdeck': 'SD',
  'Power only': 'PO',
  'Auto Carrier': 'AC',
  'Box Truck': 'BT',
  'B-Train': 'B-TR',
  'Conestoga': 'CN',
  'Containers': 'C',
  'Double Drop': 'DD',
  'Dry Bulk': 'DB',
  'Dump Trailer': 'DT',
  'Hopper Bottom': 'HB',
  'Hotshot': 'HT',
  'Lowboy': 'LB',
  'Tanker': 'T',
};

const accessorials = {
  'b-train': 'b-train',
  'sides': 'with sides',
  'tarps': 'with tarps',
  'palletexchange': 'with pallet exchange',
  'hazmat': 'hazmat',
  'maxi': 'maxi',
  'team': 'team',
  'hotshot': 'hotshot',
  'airride': 'air ride',
  'curtains': 'with curtains',
  'vented': 'vented',
  'walkingfloor': 'walking floor',
  'removablegooseneck': 'with removable gooseneck',
};

const inputValues = {
  main: ['F', 'V', 'R', 'SD', 'PO'],
  other: ['AC', 'BT', 'B-TR', 'CN', 'C', 'DD', 'DB', 'DT', 'HB', 'HT', 'LB', 'T'],
};
const newInputValues = {
  main: ['PO', 'AC', 'BT', 'B-TR', 'CN',],
  other: ['C', 'DD', 'DB', 'DT', 'HB', 'HT', 'LB', 'T'],
};
const inputValuesAll = inputValues.main.concat(inputValues.other);
const newInputValuesAll = newInputValues.main.concat(newInputValues.other);

const idToHuman = invert(humanToId);

const idToHumanMain = fromPairs(inputValues.main.map(i => [i, idToHuman[i]]));
const newIdToHumanMain = fromPairs(newInputValues.main.map(i => [i, idToHuman[i]]));
const idToHumanOther = fromPairs(inputValues.other.map(i => [i, idToHuman[i]]));
const newIdToHumanOther = fromPairs(newInputValues.other.map(i => [i, idToHuman[i]]));

const idToHumanLowerCase = mapValues(idToHuman, s => s.toLowerCase());
const idToFull = mapValues(idToHuman, v => `${v}${nbsp}(${humanToId[v]})`);
const humanLowerCaseToId = invert(idToHumanLowerCase);
const humanLowerCaseToFull = mapValues(humanLowerCaseToId, v => `${idToHuman[v]}${nbsp}(${v})`);
const humanLowerToUpper = mapValues(humanLowerCaseToId, id => idToHuman[id]);


export {
  idToHumanMain,
  newIdToHumanMain,
  idToHumanOther,
  newIdToHumanOther,
  humanToId,
  idToHuman,
  idToFull,
  idToHumanLowerCase,
  humanLowerCaseToId,
  humanLowerCaseToFull,
  accessorials,
  humanLowerToUpper,
  inputValuesAll,
  newInputValuesAll
};



// WEBPACK FOOTER //
// ./src/misc/equipment.js